import { useAuthForm } from "../hooks/useAuthForm";
import AuthBrand from "../../../shared/components/layout/BrandLogo";
import DetailsStep from "../components/DetailsStep";
import OtpStep from "../components/OtpStep";
import ModeSwitch from "../components/ModeSwitch";
import AuthCopyright from "../../../shared/components/layout/Copyright";

// Page only composes the pieces: all logic lives in useAuthForm
const AuthPage = () => {
    const form = useAuthForm();

    return (
        <>
            <div className="flex w-full min-h-[89vh] xl:min-h-[91vh] p-8 justify-center items-center">
                <div className="flex flex-col w-full md:w-3/4 lg:w-2/3 xl:w-1/3 p-5 xl:p-10 border-2 border-gray-100 shadow-md rounded-2xl">
                    <AuthBrand />

                    <h1 className="text-2xl font-bold block mt-8 mb-3 text-gray-700">
                        {form.mode === "login" ? "ورود" : "ثبت نام"}
                    </h1>

                    {form.error && (
                        // role="alert" makes screen readers announce the error
                        <p role="alert" className="text-red-500 text-md my-2 text-center">
                            {form.error}
                        </p>
                    )}

                    {form.step === "details" ? (
                        <DetailsStep
                            mode={form.mode}
                            name={form.name}
                            phone={form.phone}
                            loading={form.loading}
                            captchaKey={form.captchaKey}
                            onNameChange={form.setName}
                            onPhoneChange={form.setPhone}
                            onCaptchaChange={form.setCaptchaToken}
                            onSubmit={form.submitDetails}
                        />
                    ) : (
                        <OtpStep
                            mode={form.mode}
                            otp={form.otp}
                            loading={form.loading}
                            onOtpChange={form.setOtp}
                            onSubmit={form.submitOtp}
                            onBack={form.backToDetails}
                        />
                    )}

                    <ModeSwitch mode={form.mode} onSwitch={form.switchMode} />
                </div>
            </div>

            <AuthCopyright />
        </>
    );
};

export default AuthPage;